export default "__VITE_ASSET__RzwCzYk8__"